import OrderLayout from '@/views/layout/LayoutOrder';
import ConfirmOrder from '@/views/pay/confirmOrder';
import PayStatus from '@/views/pay/payStatus';

const payStepsRouter = {
  path: '/manage/orders',
  component: OrderLayout,
  name: 'orderPay',
  meta: {
    requireAuth: true
  },
  hidden: true,
  children: [
    {
      path: 'confirm',
      name: 'confirmOrder',
      component: ConfirmOrder,
      meta: {
        title: 'SaaS服务订单支付',
        active: 1
      },
      hidden: true
    },
    {
      path: ':orderID/payStatus',
      name: 'payStatus',
      component: PayStatus,
      meta: {
        title: '状态',
        active: 2
      },
      hidden: true
    }
  ]
};
export default payStepsRouter;



// WEBPACK FOOTER //
// ./src/router/modules/paySteps.js